import { BaseModal } from './BaseModal'
import { Button } from 'app-v2/design-systems/components/inputs/button'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { colors } from 'app-v2/design-systems/theme'
import type { WinningType } from '../../../types'
import { ModalCover } from './ModalCover'
import type { Gain } from 'shared/store/tu-preferes-king/types'
import { selectWinning } from 'shared/store/tu-preferes-king'
import { useDispatch } from 'react-redux'
import { Text } from '../../../../common/typography'
import { Spinner } from '../../../../assets/icons'

const { white, bbqBrown } = colors

type ModalProps = {
    visible: boolean,
    onClose: () => void,
    selectedWinning: Gain,
    choice: WinningType,
    tpkToken: string
}
export function ConfirmChoiceModal(props: ModalProps) {
    const intl = useIntl()
    const [sending, setSending] = useState(false)
    const dispatch = useDispatch()
    const [error, setError] = useState('')
    useEffect(() => {
        if (props.visible) {
            setError('')
        }
    }, [props.visible])

    return (
        <BaseModal
            visible={props.visible}
            onClose={props.onClose}
            title={intl.formatMessage({
                id: 'tupreferesking.duel.confirm.modal.title'
            })}
            subtitle={intl.formatMessage({
                id: 'tupreferesking.duel.confirm.modal.body'
            })}
            body={
                error ? (
                    <Text color={colors.fieryRed}>
                        {intl.formatMessage({
                            id: `tupreferesking.errors.${error.message}`
                        })}
                    </Text>
                ) : (
                    undefined
                )
            }
            buttons={
                <>
                    <Button
                        fullLength
                        variant={'outlined'}
                        buttonColor={bbqBrown}
                        labelColor={bbqBrown}
                        onClick={props.onClose}>
                        {intl.formatMessage({
                            id: 'cancel'
                        })}
                    </Button>
                    <Button
                        fullLength
                        buttonColor={bbqBrown}
                        labelColor={white}
                        disabled={sending}
                        otherStyle={{
                            padding: '0 24px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        onClick={async () => {
                            setError('')
                            setSending(true)
                            await dispatch(
                                selectWinning(props.tpkToken, props.choice)
                            )
                                .then(() => props.onClose())
                                .catch(setError)
                                .finally(() => setSending(false))
                            setSending(false)
                        }}>
                        {intl.formatMessage({
                            id: 'continue'
                        })}
                        {sending && <Spinner size={18} color={white} />}
                    </Button>
                </>
            }
            cover={
                <ModalCover
                    winning={props.selectedWinning}
                    selected={props.choice}
                />
            }
        />
    )
}
